<div class="org-detail" *ngIf="!errorMessage">
  <nb-card>
    <nb-card-header>
      <div class="detail-header">
        <button nbButton ghost size="small" (click)="back()">&larr;</button>
        <h5>{{ org?.canonical_name }}</h5>
        <span class="chip" *ngIf="isTracked">{{ 'tracked' | translate }}</span>
        <span class="chip chip-untracked" *ngIf="!isTracked">{{ 'untracked' | translate }}</span>
      </div>
    </nb-card-header>
    <nb-card-body>
      <p class="meta">{{ org?.market_vacancies_count ?? 0 }} {{ 'scrapedvacancies' | translate }}</p>
    </nb-card-body>
  </nb-card>

  <nb-card>
    <nb-card-header>{{ 'vacancies' | translate }}</nb-card-header>
    <nb-card-body>
      <div *ngIf="loading">{{ 'loading' | translate }}</div>
      <div *ngIf="vacanciesUnavailable" class="empty-state">{{ 'noaccess' | translate }}</div>

      <table class="vacancy-table" *ngIf="vacancies.length">
        <thead>
          <tr>
            <th>{{ 'title' | translate }}</th>
            <th>{{ 'location' | translate }}</th>
            <th>{{ 'deadline' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let v of vacancies" (click)="openVacancy(v)" class="clickable">
            <td>{{ v.title }}</td>
            <td>{{ v.location }}</td>
            <td>{{ v.deadline | date:'dd-MM-yyyy' }}</td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="!loading && !vacanciesUnavailable && !vacancies.length" class="empty-state">
        {{ 'noresults' | translate }}
      </div>

      <div class="pager" *ngIf="vacancyMeta && vacancyMeta.last_page > 1">
        <button nbButton ghost
                [disabled]="vacancyMeta.current_page <= 1"
                (click)="loadVacancies(vacancyMeta.current_page - 1)">&larr;</button>
        <span>{{ vacancyMeta.current_page }} / {{ vacancyMeta.last_page }}</span>
        <button nbButton ghost
                [disabled]="vacancyMeta.current_page >= vacancyMeta.last_page"
                (click)="loadVacancies(vacancyMeta.current_page + 1)">&rarr;</button>
      </div>
    </nb-card-body>
  </nb-card>

  <nb-card>
    <nb-card-header>{{ 'opportunities' | translate }}</nb-card-header>
    <nb-card-body>
      <div *ngIf="!isTracked" class="empty-state">{{ 'orgnottrackedyet' | translate }}</div>

      <table class="opp-table" *ngIf="isTracked && opportunities.length">
        <thead>
          <tr>
            <th>{{ 'title' | translate }}</th>
            <th>{{ 'status' | translate }}</th>
            <th>{{ 'role' | translate }}</th>
            <th>{{ 'submissions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let o of opportunities" (click)="openOpportunity(o)" class="clickable">
            <td>{{ o.title }}</td>
            <td>{{ ('crm.opp.' + o.status) | translate }}</td>
            <td>{{ roleKey(o) | translate }}</td>
            <td>{{ o.submissions?.length ?? 0 }}</td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="isTracked && !opportunities.length" class="empty-state">
        {{ 'noopportunitiesyet' | translate }}
      </div>
    </nb-card-body>
  </nb-card>
</div>

<div *ngIf="errorMessage" class="error-banner">{{ errorMessage }}</div>
